import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';

interface HeaderProps {
  title: string;
  type: 'rater' | 'expectation';
}

const Header: React.FC<HeaderProps> = ({ title, type }) => {
  return (
    <div className="header-table-method">
      <div className="header-table-method__column">
        <p className='m-0'>No.</p>
      </div>
      <div className="header-table-method__description_container">
        <span className="header-table-method__description">
          <h6 className='m-0'>item</h6>
        </span>
        <span className="header-table-method__description_title title">
          <h6 className="title m-0">
            {
              <>
                <span className="text-red-60">{title.charAt(0)}</span>
                {title.slice(1)}
              </>
            }
          </h6>
        </span>
        <span className="header-table-method__description">
          <h6 className='m-0'>Ability to perform promised service dependably and accurately</h6>
        </span>
      </div>

      {type === 'expectation' && (
        <>
          <div className="header-table-method__column">
            <p className='m-0'>
              1 - 6 <br /> Scale
            </p>
          </div>
        </>
      )}
      {type === 'rater' && (
        <>
          <div className="header-table-method__column">
            <p className='m-0'>Expectation Score</p>
          </div>
          <div className="header-table-method__column">
            <p className='m-0'>Realization Score</p>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
